<script setup lang="ts">
/**
 * 首次打开:填店铺/公司名即可用(本地 7 天试用)。像填用户名激活,无激活码。
 */
import { ref } from 'vue'
import { useLicenseStore } from '@/stores/license'

const license = useLicenseStore()
const name = ref('')
const err = ref<string | null>(null)
const saving = ref(false)

async function submit() {
  if (saving.value) return
  saving.value = true
  err.value = null
  try {
    await license.activate(name.value)
  } catch (e: unknown) {
    err.value = e instanceof Error ? e.message : String(e)
  } finally {
    saving.value = false
  }
}
</script>

<template>
  <div class="gate">
    <div class="card">
      <i class="ti ti-building-store" aria-hidden="true"></i>
      <h1>欢迎使用</h1>
      <p class="lead">填写店铺名或公司名即可开始使用，自动开通 7 天试用。</p>
      <label class="field">
        <span>店铺名 / 公司名</span>
        <input
          v-model="name"
          type="text"
          maxlength="80"
          placeholder="例如：广州中大 XX 面料"
          autofocus
          @keyup.enter="submit"
        />
      </label>
      <p v-if="err" class="err">{{ err }}</p>
      <button type="button" class="btn" :disabled="saving || !name.trim()" @click="submit">
        {{ saving ? '开通中…' : '开始使用' }}
      </button>
      <p class="hint">无需激活码。到期前我们会为您开通正式使用期限。</p>
    </div>
  </div>
</template>

<style scoped>
.gate {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: var(--color-page-bg);
}
.card {
  width: min(420px, 100%);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.card > i {
  font-size: 48px;
  color: var(--color-cta);
}
h1 {
  margin: 0;
  font-size: var(--fs-page);
  font-weight: var(--fw-bold);
  color: var(--color-text-primary);
}
.lead {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: var(--fs-item);
  line-height: 1.5;
}
.field {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  text-align: left;
  font-size: var(--fs-item);
  color: var(--color-text-secondary);
  margin-top: 8px;
}
.field input {
  padding: 10px 12px;
  border: 0.5px solid var(--color-border-secondary);
  border-radius: var(--border-radius-md);
  font-size: var(--fs-item);
  color: var(--color-text-primary);
  background: var(--color-background-primary);
}
.btn {
  width: 100%;
  margin-top: 8px;
  padding: 11px 16px;
  border: none;
  border-radius: var(--border-radius-md);
  background: var(--color-cta);
  color: #fff;
  font-size: var(--fs-item);
  font-weight: var(--fw-med);
  cursor: pointer;
}
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.err {
  margin: 0;
  color: var(--color-text-danger);
  font-size: var(--fs-item);
}
.hint {
  margin: 4px 0 0;
  font-size: var(--fs-micro);
  color: var(--color-text-tertiary);
}
</style>
